import { MessageService, ConfirmationService } from 'primeng/api';
import { TechnicianService } from './../../../services/technician.service';
import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-working-hours',
  templateUrl: './edit-working-hours.component.html',
  styleUrls: ['./edit-working-hours.component.scss'],
})
export class EditWorkingHoursComponent implements OnInit {
  @Input() Technician;
  @Input() Day;
  @Input() Name;
  @Input() messageService: MessageService;
  @Input() timeOff;
  public dayStart: any;
  public dayEnd: any;
  public startBreakTime: any;
  public endBreakTime: any;
  public workingHours: any = [];
  public busy = false;
  public toggle = false;
  public breaks = [];
  public recurring = false;

  constructor(
    public modal: NgbActiveModal,
    public technicianService: TechnicianService,
    public translate: TranslateService,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit() {
    switch (this.Day) {
      case 0:
        this.dayStart = 'MondayStart';
        this.dayEnd = 'MondayEnd';
        break;
      case 1:
        this.dayStart = 'TuesdayStart';
        this.dayEnd = 'TuesdayEnd';
        break;
      case 2:
        this.dayStart = 'WednesdayStart';
        this.dayEnd = 'WednesdayEnd';
        break;
      case 3:
        this.dayStart = 'ThursdayStart';
        this.dayEnd = 'ThursdayEnd';
        break;
      case 4:
        this.dayStart = 'FridayStart';
        this.dayEnd = 'FridayEnd';
        break;
      case 5:
        this.dayStart = 'SaturdayStart';
        this.dayEnd = 'SaturdayEnd';
        break;
      case 6:
        this.dayStart = 'SundayStart';
        this.dayEnd = 'SundayEnd';
        break;
    }

    let date = moment().startOf('day').toDate();
    this.workingHours.push({
      label: moment(date).format('HH:mm'),
      value: moment(date).format('HH:mm'),
    });
    for (let i = 0; i < 47; i++) {
      date.setMinutes(date.getMinutes() + 30);
      this.workingHours.push({
        label: moment(date).format('HH:mm'),
        value: moment(date).format('HH:mm'),
      });
    }
    if (this.timeOff) {
      this.timeOff.forEach((x) => {
        this.breaks.push({
          startTime: moment(x.StartTime).format('HH:mm'),
          endTime: moment(x.EndTime).format('HH:mm'),
          ID: x.ID,
          Description: x.Description,
          recurrenceID: x.recurrenceID,
        });
      });
    }
  }

  delete() {
    this.Technician[this.dayStart] = null;
    this.Technician[this.dayEnd] = null;
    this.save();
  }

  save() {
    this.saveShift();
  }

  dayOfWeek() {
    switch (this.Day) {
      case 0:
        return this.translate.instant('general.monday');
        break;
      case 1:
        return this.translate.instant('general.tuesday');
        break;
      case 2:
        return this.translate.instant('general.wednesday');
        break;
      case 3:
        return this.translate.instant('general.thursday');
        break;
      case 4:
        return this.translate.instant('general.friday');
        break;
      case 5:
        return this.translate.instant('general.saturday');
        break;
      case 6:
        return this.translate.instant('general.sunday');
        break;
    }
  }

  saveShift() {
    if (this.Day === 0) {
      this.copyShift();
    } else {
      this.busy = true;
      this.technicianService
        .saveTechnicianWorkHours(this.Technician)
        .subscribe((result) => {
          this.messageService.add({
            life: 5000,
            detail: this.translate.instant(
              'bikeshop.modal.add_edit_user.technician_working_hours_form.working_hours_saved',
            ),
          });
          this.busy = false;
          if (this.breaks.length) {
            this.saveBreakTime();
          } else {
            this.modal.close();
          }
        });
    }
  }

  copyShift() {
    this.confirmationService.confirm({
      key: 'user_key',
      header: this.translate.instant('general.confirm'),
      acceptLabel: this.translate.instant('general.yes'),
      rejectLabel: this.translate.instant('general.no'),
      message: this.translate.instant('messages.user_copy_time'),
      accept: () => {
        this.busy = true;
        this.Technician.MondayStart = this.Technician[this.dayStart];
        this.Technician.TuesdayStart = this.Technician[this.dayStart];
        this.Technician.WednesdayStart = this.Technician[this.dayStart];
        this.Technician.ThursdayStart = this.Technician[this.dayStart];
        this.Technician.FridayStart = this.Technician[this.dayStart];

        this.Technician.MondayEnd = this.Technician[this.dayEnd];
        this.Technician.TuesdayEnd = this.Technician[this.dayEnd];
        this.Technician.WednesdayEnd = this.Technician[this.dayEnd];
        this.Technician.ThursdayEnd = this.Technician[this.dayEnd];
        this.Technician.FridayEnd = this.Technician[this.dayEnd];
        this.technicianService
          .saveTechnicianWorkHours(this.Technician)
          .subscribe((result) => {
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant(
                'bikeshop.modal.add_edit_user.technician_working_hours_form.working_hours_saved',
              ),
            });
            this.busy = false;
            if (this.breaks.length) {
              this.saveBreakTime();
            } else {
              this.modal.close();
            }
          });
      },
      reject: () => {
        this.busy = true;
        this.technicianService
          .saveTechnicianWorkHours(this.Technician)
          .subscribe((result) => {
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant(
                'bikeshop.modal.add_edit_user.technician_working_hours_form.working_hours_saved',
              ),
            });
            this.busy = false;
            if (this.breaks.length) {
              this.saveBreakTime();
            } else {
              this.modal.close();
            }
          });
      },
    });
  }

  saveBreakTime() {
    this.breaks.forEach((element) => {
      let breakStart = new Date();
      //breakStart.setDate(this.Date.split(" ")[1]);
      breakStart.setMinutes(element.startTime.split(':')[1]);
      breakStart.setHours(element.startTime.split(':')[0]);
      let breakEnd = new Date();
      //breakEnd.setDate(this.Date.split(" ")[1]);
      breakEnd.setMinutes(element.endTime.split(':')[1]);
      breakEnd.setHours(element.endTime.split(':')[0]);
      let tzoffset = new Date().getTimezoneOffset() * 60000;
      const startTime = new Date(
        breakStart.getFullYear(),
        breakStart.getMonth(),
        breakStart.getDate(),
        breakStart.getHours(),
        breakStart.getMinutes(),
        0,
      ).getTime();
      const endTime = new Date(
        breakEnd.getFullYear(),
        breakEnd.getMonth(),
        breakEnd.getDate(),
        breakEnd.getHours(),
        breakEnd.getMinutes(),
        0,
      ).getTime();
      this.busy = true;
      if (!element.ID) {
        this.technicianService
          .createCalendarEvent(
            this.Technician.TechnicianID,
            'Admin Time',
            moment(startTime - tzoffset).toISOString(false),
            moment(endTime - tzoffset).toISOString(false),
            this.recurring,
            this.recurring ? 200 : 0,
            1,
          )
          .subscribe((event) => {
            this.busy = false;
            this.modal.close();
          });
      } else {
        this.technicianService
          .updateCalendarEvent(
            element.ID,
            this.Technician.TechnicianID,
            element.Description,
            element.startTime,
            element.endTime,
            element.recurrenceID,
            element.duration,
            element.isActive,
          )
          .subscribe((res) => {
            this.busy = false;
            this.modal.close();
          });
      }
    });
  }

  addBreak() {
    this.breaks.push({ startTime: null, endTime: null });
  }
}
